import { render, staticRenderFns } from "./AlarmListNew.vue?vue&type=template&id=bb5ed19e&"
import script from "./AlarmListNew.vue?vue&type=script&lang=js&"
export * from "./AlarmListNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb5ed19e')) {
      api.createRecord('bb5ed19e', component.options)
    } else {
      api.reload('bb5ed19e', component.options)
    }
    module.hot.accept("./AlarmListNew.vue?vue&type=template&id=bb5ed19e&", function () {
      api.rerender('bb5ed19e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/Alarm/AlarmListNew.vue"
export default component.exports